import React from 'react';
import { useTitle } from './TitleContext';

const Header = () => {
    const { title } = useTitle(); // Use the title from context

    return (
        <h1 className="main-header">{title}<span className="will-hurd"> for Will Hurd</span></h1>
    );
}

export default Header;